import React, { forwardRef } from 'react'
import cx from 'classnames'

import s from './WidthContainer.scss'


type WidthContainerProps = {
  children?: React.ReactNode
  className?: string
  contentCenter?: boolean
  inline?: boolean // it's useful when u need horizontal paddings on mobile for scrollable content with items
  role?: string
  id?: string
  dataTestId?: string
  ariaLabel?: string
  size?: 560 | 700 | 1136
  style?: React.CSSProperties
}

const WidthContainer = forwardRef<HTMLDivElement, WidthContainerProps>((props, ref) => {
  const {
    children, className, id, style,
    inline, contentCenter,
    role, dataTestId, ariaLabel,
    size = 1136,
  } = props

  const rootClassName = cx(s.container, className, {
    [s[`size-${size}`]]: size,
    [s.inline]: inline,
    [s.contentCenter]: contentCenter,
  })

  return (
    <div
      id={id}
      className={rootClassName}
      ref={ref}
      style={style}
      role={role}
      data-testid={dataTestId}
      aria-label={ariaLabel}
    >
      {children}
    </div>
  )
})


export default WidthContainer
